import { useLocation } from '../../app/route';

export function useQueryClientName() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  return query.get('name') || '';
}
